import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_pressure-led-combo/artifacts/l8lj5yi5_Shine%26Line%20logo.jpg",
  hero: "https://static.prod-images.emergentagent.com/jobs/cb498313-9f14-49d6-83f2-b691ac9992ec/images/96e09a722404e37a745579b659b6a2e28ffc35e71a96958d1baf47340a5c23bb.png",
  pw_before: "/images/pw_before.png",
  pw_after: "/images/pw_after.png",
  led_before: "/images/led_before.png",
  led_after: "/images/led_after.png",
  team_alex: "https://static.prod-images.emergentagent.com/jobs/cb498313-9f14-49d6-83f2-b691ac9992ec/images/b2b459962b58e65d376dedf26e8c4594174b739ef3c193a2d4ee6157d9f3d17a.png",
  team_samuel: "https://static.prod-images.emergentagent.com/jobs/cb498313-9f14-49d6-83f2-b691ac9992ec/images/2d2d7dce2b90be0f72fba9f3c6c913a2c9192bb552233bd09f19e0e033e27cc8.png",
  team_caleb: "https://static.prod-images.emergentagent.com/jobs/cb498313-9f14-49d6-83f2-b691ac9992ec/images/f82c40424fa2fe92c865418e88a5da0f35f8638f5a823d2e8856fa9cd802c957.png",
};

export const CONTACT = {
  email: "shineandlineservices@gmail.com",
  phone: "022 689 0588",
  location: "Rangiora, New Zealand",
};
